import { useEffect, useState } from "react";
import { http } from "@/lib/api";

// In-memory cache so we only fetch site special once per session
let _siteSpecialCache = null;
let _siteSpecialPromise = null;

/**
 * Animated gold "sale" pill. Shows when either (a) artwork.special.active or
 * (b) the site-wide special is active. The artwork prop is optional —
 * when omitted we still render the site special if active.
 */
export default function SpecialBadge({ artwork, className = "", size = "sm" }) {
  const [siteSpecial, setSiteSpecial] = useState(() => _siteSpecialCache);

  useEffect(() => {
    if (_siteSpecialCache !== null) return;
    if (!_siteSpecialPromise) {
      _siteSpecialPromise = http.get("/public/pricing")
        .then(({ data }) => { _siteSpecialCache = data.site_special || null; return _siteSpecialCache; })
        .catch(() => { _siteSpecialCache = null; return null; });
    }
    _siteSpecialPromise.then(s => setSiteSpecial(s));
  }, []);

  const artSpecial = artwork?.special;
  const showArt = artSpecial?.active && (artSpecial?.label || artSpecial?.sale_price || Number(artSpecial?.pct_off) > 0);
  const showSite = siteSpecial?.active && Number(siteSpecial?.pct_off) > 0;
  if (!showArt && !showSite) return null;

  let label;
  if (showArt) {
    if (artSpecial.label) label = artSpecial.label;
    else if (Number(artSpecial.pct_off) > 0) label = `${artSpecial.pct_off}% OFF`;
    else label = "ON SALE";
  } else {
    label = `${siteSpecial.label || "FLASH SALE"} · ${siteSpecial.pct_off}% OFF`;
  }

  const sizeCls = size === "lg"
    ? "text-[12px] px-3 py-1.5 tracking-[0.32em]"
    : "text-[9px] px-2 py-1 tracking-[0.28em]";

  return (
    <span
      className={`stc-special-badge inline-block font-ui uppercase ${sizeCls} ${className}`}
      data-testid="special-badge"
    >
      {label}
    </span>
  );
}
